import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { ClientOnboardingComponent } from './client-onboarding.component';

export const routes = [
  { path: '', component: ClientOnboardingComponent,       }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ClientOnboardingRoutingModule { }
